<template>
  <div class="health-dashboard-container">
    <el-button-group>
      <el-button class="healthButton healthActive" @click="click(0)">数字档案</el-button>
      <!-- <el-button
        class="healthButton"
        style="background-color: #ebedf0"
        @click="click(1)"
        >重大疾病风险状态
      </el-button> -->
      <el-button class="healthButton" @click="click(6)">药物方案</el-button>
      <el-button class="healthButton" @click="click(2)">健康达标报告</el-button>
      <el-button class="healthButton" @click="click(3)">健康管理方案</el-button>
      <el-button class="healthButton" @click="click(4)">行为认知治疗</el-button>
      <el-button class="healthButton" @click="click(5)">运动随访</el-button>
    </el-button-group>
    <div class="page-header">
      <div class="header-left">
        <div class="logo-icon"><i class="el-icon-s-custom"></i></div>
        <h2 class="page-title">个人健康数据中心</h2>
        <el-tag size="small" effect="plain" class="header-tag">数据缝合·风险可视·方案协同</el-tag>
      </div>
    </div>

    <el-row :gutter="16" class="dashboard-row">
      <el-col :span="7">
        <el-card class="custom-card profile-card" shadow="never">
          <div slot="header" class="card-header user">
            <img src="@/assets/img/user-info.png" />
            <div>个人信息展示</div>
            <!-- <span class="title-with-icon"><i class="el-icon-user-solid text-orange"></i> 个人信息展示</span> -->
          </div>
          <div class="profile-info light-gray-bg">
            <div class="info-row font-bold text-md flex-around">
              <span>姓名: 郭苗苗</span>
              <el-divider direction="vertical"></el-divider>
              <span>性别: 女</span>
              <el-divider direction="vertical"></el-divider>
              <span>年龄: 35</span>
            </div>
            <div class="text-sm text-gray mt-15">健康状态: 有慢性病，需要长期监测</div>
            <div class="text-sm text-gray mt-5">专属健康管理师: 沐沐</div>
          </div>
        </el-card>
        <el-card class="custom-card" shadow="never">
          <div slot="header" class="card-header">
            <span class="title-with-icon"><i class="el-icon-menu icon-blue"></i> 数据缝合全景图</span>
            <el-tag size="mini" type="info" class="rounded-tag">最后一次融合时间: 2026-2-4</el-tag>
          </div>
          <div class="data-source-list">
            <div class="source-item light-blue-box">
              <div class="item-title">
                <i class="el-icon-success icon-green"></i> 医院系统连接
                <el-tag size="mini" effect="plain" class="ml-10">HIS 就诊记录</el-tag>
              </div>
              <div class="item-desc">南京市第一人民医院(HIS系统) <span class="float-right">最后同步:2025年12月15日</span></div>
              <div class="item-desc mt-5">包含:门诊记录、检查报告、用药记录</div>
            </div>
            <div class="source-item light-blue-box mt-10">
              <div class="item-title">
                <i class="el-icon-success icon-green"></i> 体检中心数据
                <el-tag size="mini" effect="plain" class="ml-10">定期体检</el-tag>
              </div>
              <div class="item-desc">美年大健康体检中心 <span class="float-right">最后同步:2025年12月15日</span></div>
              <div class="item-desc mt-5">包含:血常规、生化全套、影像检查</div>
            </div>
          </div>
          <div class="section-subtitle mt-15"><span class="dot blue"></span> 家庭监测设备 (实时连接)</div>
          <div class="device-grid mt-10">
             <div class="device-box dashed-border" v-for="(dev, index) in devices" :key="index">
                <div class="dev-header">
                  <span><i class="el-icon-mobile"></i> {{ dev.name }}</span>
                  <span class="text-xs text-gray">{{ dev.model }}</span>
                </div>
                <div class="dev-data mt-5">今日测量: {{ dev.count }}次</div>
                <div class="dev-data">平均值: {{ dev.avg }}</div>
             </div>
          </div>
        </el-card>
        <el-card class="custom-card mt-16" shadow="never">
          <div slot="header" class="card-header">
            <span class="title-with-icon"><i class="el-icon-s-data icon-blue"></i> 关键指标动态追踪</span>
            <el-tag size="mini" type="info" class="rounded-tag">实时监测·自动预警·轨迹可回看</el-tag>
          </div>
          <div class="section-subtitle"><span class="dot blue"></span> 血压检测</div>
          <!-- <el-table :data="bpList" size="mini" class="borderless-table mt-10" :header-cell-style="{background:'#f8faff', color:'#666'}">
            <el-table-column prop="time" label="时间段" align="center"></el-table-column>
            <el-table-column prop="sys" label="收缩压" align="center"></el-table-column>
            <el-table-column prop="dia" label="舒张压" align="center"></el-table-column>
            <el-table-column prop="status" label="状态" align="center">
              <template slot-scope="scope">
                <span :class="scope.row.status === '偏高' ? 'text-orange' : 'text-green'">{{ scope.row.status }}</span>
              </template>
            </el-table-column>
          </el-table> -->
          <img style="width:100%;height:auto;" src="@/assets/img/press.png" />
          <div class="section-subtitle mt-15"><span class="dot blue"></span> 血糖记录</div>
          <div class="flex-between text-sm mt-10">
            <img style="width:100%;height:auto;" src="@/assets/img/sugar.png" />
          </div>
          <!-- <div class="flex-between text-sm mt-10">
            <span>餐后2小时: <span class="font-bold">9.2</span> mmol/L(目标&lt;10.0)</span>
            <el-tag size="mini" type="success" effect="plain">可接受范围</el-tag>
          </div> -->
          <div class="alert-box mt-15">
            <div class="alert-title"><i class="el-icon-warning text-red"></i> 今日异常预警</div>
            <div class="alert-desc mt-5">上午血压偏高提醒已发送至手环，并记录在异常事件列表。</div>
            <div class="alert-desc">昨日晚餐后血糖短时超标，已推送饮食建议。</div>
          </div>
        </el-card>
        <el-card class="custom-card mt-16" shadow="never">
          <div slot="header" class="card-header user">
            <img src="@/assets/img/sleep.png" />
            <div>睡眠评估</div>
            <!-- <span class="title-with-icon"><i class="el-icon-office-building icon-blue"></i> 就医协作</span> -->
          </div>
          <div class="target-box light-blue-box mt-10" style="margin-top:0;">
            <div class="text-sm text-gray mt-10">夜间平均睡眠时长：7小时</div>
            <div class="text-sm text-gray mt-10">深度睡眠：30%</div>
            <div class="text-sm text-gray mt-5">浅度睡眠：20%</div>
            <div class="text-sm text-gray mt-5">快速眨眼时间：20%</div>
        </div>
        </el-card>
      </el-col>

      <el-col :span="10">
        <el-card class="custom-card mt-16" shadow="never">
          <div slot="header" class="card-header">
            <span class="title-with-icon"><i class="el-icon-tickets icon-blue"></i> 功能量表评估</span>
            <el-tag size="mini" class="rounded-tag custom-blue-tag">标准化评估·状态量化·趋势追踪</el-tag>
          </div>
          <div class="scale-grid">
            <div class="scale-item light-blue-box" v-for="(item, index) in scales" :key="index">
              <div class="font-bold text-center">{{ item.name }}</div>
              <div class="text-xs text-gray text-center mt-5">评估时间: {{ item.date }}</div>
              <div class="text-sm text-center mt-10">
                得分: {{ item.score }} &nbsp;
                状态: <span :class="item.colorClass">{{ item.status }}</span>
              </div>
            </div>
          </div>
          <div class="text-xs text-gray mt-10">综合分析：用户有抑郁风险，请关注</div>
        </el-card>
        <el-card class="custom-card" shadow="never">
          <div slot="header" class="card-header">
            <span class="title-with-icon"><i class="el-icon-document icon-blue"></i> 健康风险快照</span>
            <el-tag size="mini" class="rounded-tag custom-blue-tag">今日评估已完成</el-tag>
          </div>
          <div class="text-xs text-gray mb-15">最新评估时间: 今日09:30 &nbsp;&nbsp; 基于医院+体检+家庭设备多源数据</div>
          <div class="risk-item">
            <div class="risk-title text-red"><span class="dot red"></span>高风险风险（严密观察）</div>
            <div class="risk-content red-box mt-10">
              <div class="font-bold text-md">心血管疾病风险</div>
              <div class="text-sm text-gray mt-5">主要影响因素: 高血压病史、LDL-C偏高。</div>
              <div class="text-sm text-gray mt-5">建议: 加强晨间血压监测频率，配合生活方式干预评估是否调整降脂方案。</div>
            </div>
          </div>
          <div class="risk-item mt-15">
            <div class="risk-title text-orange"><span class="dot orange"></span> 中等风险（重点检测）</div>
            <div class="risk-content yellow-box mt-10">
              <div class="font-bold text-md">心血管疾病风险</div>
              <div class="text-sm text-gray mt-5">主要影响因素: 高血压病史、LDL-C偏高。</div>
              <div class="text-sm text-gray mt-5">建议: 加强晨间血压监测频率，配合生活方式干预评估是否调整降脂方案。</div>
            </div>
            <div class="risk-content yellow-box mt-10">
              <div class="font-bold text-md">糖尿病并发症风险</div>
              <div class="text-sm text-gray mt-5">主要影响因素: 高血压病史、LDL-C偏高。</div>
              <div class="text-sm text-gray mt-5">建议: 加强晨间血压监测频率，配合生活方式干预评估是否调整降脂方案。</div>
            </div>
          </div>

          <div class="risk-item mt-15">
            <div class="risk-title text-green"><span class="dot green"></span> 低风险（常规随访）</div>
            <div class="risk-content green-box mt-10">
              <div class="font-bold text-md">心血管疾病风险</div>
              <div class="text-sm text-gray mt-5">主要影响因素: 高血压病史、LDL-C偏高。</div>
              <div class="text-sm text-gray mt-5">建议: 加强晨间血压监测频率，配合生活方式干预评估是否调整降脂方案。</div>
            </div>
          </div>
        </el-card>
        <el-card class="custom-card mt-16 plan-card" shadow="never">
          <div slot="header" class="card-header">
            <span class="title-with-icon"><i class="el-icon-document-checked icon-blue"></i> 本周个性化健康管理方案</span>
          </div>
          <div class="plan-section">
            <div class="target-box light-blue-box mt-10" style="margin-top:0;">
              <div class="font-bold text-md goal">
                <img src="@/assets/img/goal.png" />
                <div>本周重点管理目标</div>
                <!-- <i class="el-icon-aim text-red"></i> 本周重点管理目标 -->
              </div>
              <div class="text-sm text-gray mt-5">主要缺项: 2024年体检报告未上传。</div>
              <div class="text-sm text-gray mt-5">建议: 提醒用户在小程序或者app中上传体检报告</div>
            </div>
          </div>

          <div class="plan-section mt-20">
            <div class="target-box light-blue-box mt-10">
                <!-- <div class="font-bold text-md"><i class="el-icon-date text-orange"></i> 每日执行计划(周一至周五)</div> -->
                <div class="font-bold text-md calendar">
                    <img src="@/assets/img/calendar.png" />
                    <div>每日执行计划(周一至周五)</div>
                </div>
                <ul class="task-list text-sm text-gray light-blue-box mt-10">
                    <li>测量血压并服药(手环提醒+打卡)。</li>
                    <li>用户是否按照健康食谱用餐</li>
                    <li>睡眠准备(手环助眠模式+蓝光提醒)。</li>
                    <li>每天微信沟通一次</li>
                    <li>客户是否有复查任务，及时提醒</li>
                    <li>有异常情况及时与客户沟通确认</li>
                </ul>
            </div>
          </div>
        </el-card>
      </el-col>

      <el-col :span="7">
        <el-card class="custom-card mt-16" shadow="never">
          <div slot="header" class="card-header user">
            <img src="@/assets/img/knows.png" />
            <div>认知行为治疗</div>
            <!-- <span class="title-with-icon"><i class="el-icon-office-building icon-blue"></i> 就医协作</span> -->
          </div>
          <div class="target-box light-blue-box mt-10" style="margin-top:0;">
            <div class="font-bold text-sm">临床营养指导</div>
            <ul class="task-list text-sm text-gray light-blue-box mt-10">
                <li>以逆转糖尿病前期/2型糖尿病为核心目标，严格控糖、控脂、控热量，优先改善胰岛素抵抗;</li>
                <li>同步干预脂肪肝、高血脂、高血压三大代谢异常，采用低升糖指数(GI55)、低饱和脂肪(7%总热量)、限钠 (1500mg/d)、富膳食纤维（≥30g/d）饮食模式;</li>
                <li>所有食材选择新鲜、少加工、无添加，烹饪以蒸、煮、炖、凉拌、快炒为主，禁红烧、糖醋、腌腊。</li>
            </ul>
          </div>
          <div class="target-box light-blue-box mt-10">
            <div class="font-bold text-sm">运动处方指导</div>
            <!-- <el-table :data="sportList" size="mini" class="borderless-table mt-10" :header-cell-style="{background:'#f8faff', color:'#666'}">
                <el-table-column prop="name" label="运动名称" align="center"></el-table-column>
                <el-table-column prop="sys" label="次数" align="center"></el-table-column>
                <el-table-column prop="dia" label="时长" align="center"></el-table-column>
                <el-table-column prop="dia" label="消耗量" align="center"></el-table-column>
            </el-table> -->
            <div class="text-sm text-gray mt-10">运动频率(F):每周5天有氧+2天力量训练，含1天主动恢复，总频次7天/周</div>
            <div class="text-sm text-gray mt-5">运动强度(I): 有氧运动：心率控制在（220-年龄）x50%-65%即84-109次/分(靶心率区间)，RPE主观疲劳量表4-6分（轻度至中度呼吸加快、可连续对话);力量训练：采用自重或弹力带抗阻，每组动作RPE5-7分（肌肉中等酸胀感，无震颤或代偿)，避免Valsalva动作以防血压骤升</div>
            <div class="text-sm text-gray mt-5">运动时间(T): 每日45-60分钟（含热身5min+主运动30-45min+整理5-10min)动态热身→专项主运动→静态拉伸</div>
            <div class="text-sm text-gray mt-5">运动结构(T):+呼吸放松→居家微运动（如睡前踝泵、深蹲保持)</div>
          </div>
        </el-card>
        <el-card class="custom-card mt-16" shadow="never">
          <div slot="header" class="card-header user">
            <img src="@/assets/img/medication.png" />
            <div>药物治疗</div>
            <!-- <span class="title-with-icon"><i class="el-icon-office-building icon-blue"></i> 就医协作</span> -->
          </div>
            <el-table :data="mList" size="mini" class="borderless-table mt-10" :header-cell-style="{background:'#f8faff', color:'#666'}">
                <el-table-column prop="name" label="药物名称" align="center"></el-table-column>
                <el-table-column prop="sys" label="服用剂量" align="center"></el-table-column>
                <el-table-column prop="dia" label="服用频次" align="center"></el-table-column>
                <el-table-column prop="dia" label="服用时间" align="center"></el-table-column>
            </el-table>
        </el-card>
        <el-card class="custom-card mt-16" shadow="never">
          <div slot="header" class="card-header user">
            <img src="@/assets/img/inspection.png" />
            <div>复查提醒</div>
            <!-- <span class="title-with-icon"><i class="el-icon-office-building icon-blue"></i> 就医协作</span> -->
          </div>
          <div class="target-box light-blue-box mt-10" style="margin-top:0;">
            <div class="text-sm text-gray mt-10">腹部彩超（肝胆胰脾）：鉴于结节为TI-RADS3类，建议6-12个月复查；  复查时间：2026-3-12前</div>
            <div class="text-sm text-gray mt-10">腹部彩超（肝胆胰脾）：鉴于结节为TI-RADS3类，建议6-12个月复查；  复查时间：2026-3-12前</div>
        </div>
        </el-card>
        <el-card class="custom-card mt-16" shadow="never">
          <div slot="header" class="card-header user">
            <img src="@/assets/img/hospital.png" />
            <div>就医协作</div>
            <!-- <span class="title-with-icon"><i class="el-icon-office-building icon-blue"></i> 就医协作</span> -->
          </div>
          <div class="target-box light-blue-box mt-10" style="margin-top:0;">
            <div class="font-bold text-sm">预约挂号通道(最近3次)</div>
            <div class="text-sm text-gray mt-10">2025.12.10 · 心内科 · 李主任</div>
            <div class="text-sm text-gray mt-5">2026.01.15 · 内分泌科 · 张主任</div>
        </div>
        </el-card>
        <el-card class="custom-card mt-16" shadow="never">
          <div slot="header" class="card-header">
            <span class="title-with-icon"><i class="el-icon-refresh icon-blue"></i> 数据融合质量与更新</span>
            <el-tag size="mini" class="rounded-tag custom-blue-tag">健康分数: 88</el-tag>
          </div>
          <div class="quality-box light-blue-box">
            <div class="font-bold">数据完整性</div>
            <div class="text-sm text-gray mt-5">主要缺项: 2024年体检报告未上传。</div>
            <div class="text-sm text-gray mt-5">建议: 提醒用户在小程序或者app中上传体检报告</div>
          </div>
          <div class="update-box mt-15 light-blue-box">
            <div class="font-bold">数据更新计划</div>
            <div class="text-sm text-gray mt-5">下次全面数据融合: 2026-03-01</div>
            <div class="text-sm text-gray mt-5">风险快照重评估: 每周日22:00自动进行，并推送简报。</div>
          </div>
        </el-card>
      </el-col>

    </el-row>
  </div>
</template>

<script>
export default {
  name: 'HealthDashboard',
  data() {
    return {
      // 家庭监测设备 Mock 数据
      devices: [
        { name: '血压计', model: '欧姆龙HEM-7124', count: 3, avg: '126/85 mmHg' },
        { name: '血糖仪', model: '欧姆龙HEM-7124', count: 3, avg: '126/85 mmHg' },
        { name: '健康手环', model: '欧姆龙HEM-7124', count: 3, avg: '126/85 mmHg' },
        { name: '健康档案', model: '欧姆龙HEM-7124', count: 3, avg: '126/85 mmHg' }
      ],
      // 血压表格 Mock 数据
      bpList: [
        { time: '早餐', sys: 132, dia: 86, status: '偏高' },
        { time: '中餐', sys: 132, dia: 86, status: '正常' },
        { time: '晚餐', sys: 132, dia: 86, status: '正常' }
      ],
      sportList: [
        { name: '早餐', sys: 132, dia: 86, status: '偏高' },
        { name: '中餐', sys: 132, dia: 86, status: '正常' },
        { name: '晚餐', sys: 132, dia: 86, status: '正常' }
      ],
      mList: [
        { name: '络活喜', sys: 132, dia: 86, status: '偏高' },
        { name: '络活喜', sys: 132, dia: 86, status: '正常' },
        { name: '络活喜', sys: 132, dia: 86, status: '正常' }
      ],
      // 量表 Mock 数据
      scales: [
        { name: 'PHQ-9抑郁量表', date: '025.12.10', score: 6, status: '轻微', colorClass: 'text-green' },
        { name: 'PHQ-9抑郁量表', date: '025.12.10', score: 6, status: '中等', colorClass: 'text-orange' },
        { name: 'PHQ-9抑郁量表', date: '025.12.10', score: 6, status: '高危', colorClass: 'text-red' }
      ],
      wxUserid: this.$route.query.wxUserId,
    }
  },
    created() {
    this.wxUserId = this.$route.query.wxUserId
  },
  methods: {
    click(index) {
      let path = ''
      switch (index) {
        case 0:
          path = '/doctor/digitalarchive'
          break
        case 1:
          path = '/doctor/criticalillness'
          break
        case 2:
          path = '/doctor/healthreport'
          break
        case 3:
          path = '/doctor/healthmanage'
          break
        case 4:
          path = '/doctor/cognitivebehaviorald'
          break
        case 5:
          path = '/doctor/motionFollowDetail'
          break
        case 6:
          path = '/doctor/drugDetails'
          break
      }
      const parameter = {
        wxUserId: this.wxUserid
      }
      this.$router.push({
        path: path,
        query: parameter
      })
    },
  }
}
</script>

<style scoped>
/* ================== 全局与容器 ================== */
.health-dashboard-container {
  background-color: #f2f5fa; /* 底层浅灰蓝背景 */
  padding: 20px;
  min-height: 100vh;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
}

/* ================== 顶部导航栏 ================== */
.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-left: 5px;
  margin-top:20px;
}
.header-left {
  display: flex;
  align-items: center;
}
.logo-icon {
  width: 32px;
  height: 32px;
  background-color: #409eff;
  color: #fff;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 12px;
  font-size: 18px;
}
.page-title {
  font-size: 20px;
  font-weight: bold;
  color: #333;
  margin: 0;
  margin-right: 15px;
}
.header-tag {
  border-radius: 12px;
  background-color: #eef5ff;
  border-color: #d1e3fa;
  color: #409eff;
}

/* ================== 卡片基础重写 ================== */
.custom-card {
  border-radius: 10px;
  border: none;
  margin-bottom:10px;
}
/* 穿透修改 Element UI 的默认内边距 */
.custom-card >>> .el-card__header {
  padding: 14px 16px;
  border-bottom: 1px solid #f0f2f5;
}
.custom-card >>> .el-card__body {
  padding: 16px;
}
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.title-with-icon {
  font-size: 15px;
  font-weight: bold;
  color: #333;
  display: flex;
  align-items: center;
}
.title-with-icon i {
  margin-right: 6px;
  font-size: 16px;
}

/* ================== 通用背景色块 ================== */
.light-blue-box {
  background-color: #E6EFFC;
  border-radius: 6px;
  padding: 12px;
  color:#909090;
  font-size: 13px;
}
.yellow-box {
  background-color: #fff9ed;
  border-radius: 6px;
  padding: 12px;
}
.red-box{
  border-radius: 6px;
  padding: 12px;
  background-color: #fff4f4;
}
.alert-box {
  background-color: #fff4f4;
  border: 1px solid #ffdede;
  border-radius: 6px;
  padding: 12px;
}
.light-gray-bg {
  background-color: #E6EFFC;
  border-radius: 6px;
  padding: 16px;
}
.green-box{
    background-color: #F7FFF7;
    border-radius: 6px;
    padding: 12px;
}

/* ================== 通用辅助类 ================== */
.mt-5 { margin-top: 5px; }
.mt-10 { margin-top: 10px; }
.mt-15 { margin-top: 15px; }
.mt-20 { margin-top: 20px; }
.ml-10 { margin-left: 10px; }
.mb-15 { margin-bottom: 15px; }

.text-xs { font-size: 12px; }
.text-sm { font-size: 13px; line-height: 1.4; }
.text-md { font-size: 14px; }
.font-bold { font-weight: bold; color:#333; }

.text-gray { color: #8c939d; }
.text-green { color: #67c23a; }
.text-orange { color: #e6a23c; }
.text-red { color: #f56c6c; }
.icon-blue { color: #409eff; }
.icon-green { color: #67c23a; }

.float-right { float: right; }
.text-center { text-align: center; }
.flex-between { display: flex; justify-content: space-between; align-items: center; }
.flex-around { display: flex; justify-content: space-around; align-items: center; }
.el-icon-success{
    margin:2px 4px 0 0;
}
/* 状态小圆点 */
.dot {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 2px;
  margin-top: -2px;
  vertical-align: middle;
}
.dot.blue { background-color: #409eff; }
.dot.orange { background-color: #e6a23c; }
.dot.green { background-color: #67c23a; }

/* 标签类 */
.rounded-tag { border-radius: 12px; }
.custom-blue-tag { background-color: #eef5ff; color: #409eff; border: none; }
.borderless-tag { border: none; background: transparent; }

/* ================== 局部特殊样式 ================== */
/* 列表项结构 */
.item-title { font-size: 14px; font-weight: bold; margin-bottom: 8px; display: flex; align-items: center; color: #333;}
.section-subtitle { font-size: 14px; font-weight: bold; color: #333; }

/* 设备网格 (使用 CSS Grid 实现 2x2 完美对齐) */
.device-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
}
.device-box {
  padding: 10px;
  border-radius: 4px;
}
.dashed-border {
  border: 1px dashed #dcdfe6;
}
.dev-header {
  display: flex;
  justify-content: space-between;
  font-size: 13px;
  font-weight: bold;
}
.dev-data {
  font-size: 12px;
  color: #666;
}

/* 隐藏表格外部边框 */
.borderless-table::before { display: none; }
.borderless-table >>> th.el-table__cell { border-bottom: none; }
.borderless-table >>> td.el-table__cell { border-bottom: 1px solid #f0f2f5; }

/* 预警区块 */
.alert-title { font-size: 13px; font-weight: bold; color: #f56c6c; display: flex; align-items: center; }
.alert-title i { margin-right: 4px; }
.alert-desc { font-size: 12px; color: #666; line-height: 1.5; }

/* 量表三等分网格 */
.scale-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
}
.scale-item {
  padding: 12px 8px;
}
/* 任务列表 */
.task-list {
  padding-left: 20px;
  margin: 0;
}
.task-list li {
  margin-bottom: 6px;
  list-style-type: decimal;
}
.user{
    display: flex;
    justify-content: flex-start;
    font-weight: bold;
    /* border:2px solid red; */
}
.user img{
    width:24px;
    height:24px;
    margin-right:4px;
}
.goal{
    display: flex;
    justify-content: flex-start;
    margin-bottom:10px;
}
.goal img{
    width:20px;
    height:20px;
    margin-right:4px;
}
.calendar{
    display: flex;
    justify-content: flex-start;
}
.calendar img{
    width:20px;
    height:20px;
    margin-right:4px;
}
.healthButton {
  /* background-color: #ebedf0; */
  color: black;
  border: 0px solid #c1c3c5;
  border-bottom: none;
  font-size: 15px;
  border-radius: 0px;
  margin-bottom: 2px;
}
.healthActive {
  border-bottom: 3px solid #409eff;
  color: #409eff;
  font-weight: bold;
}
</style>
